export const navigateToLocale = (locale?: string): string => {
  if (locale === "en") {
    return `/${locale}/`;
  } else {
    return "/";
  }
};
